// Eventos de conversión: CTA principal, inicio de formulario, envío,
// uso de la calculadora y clic en WhatsApp.
// Se envían a dataLayer (GTM) y a PostHog si están disponibles.
export const trackEvent = (name, params = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
    if (window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(name, params);
    }
  } catch (e) {
    // El tracking nunca debe romper la experiencia
  }
};

export const EVENTS = {
  CTA_PRINCIPAL: "cta_principal_click",
  FORM_START: "formulario_inicio",
  FORM_SUBMIT: "formulario_envio",
  CALCULATOR_USE: "calculadora_uso",
  WHATSAPP_CLICK: "whatsapp_click",
  CHAT_USE: "chatbot_uso",
};
